import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class MfComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentMf | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.conditional = {
			show: settings?.conditional?.show,
			when: settings?.conditional?.when,
			eq:   settings?.conditional?.eq ?? '',
		};
		this.defaultValue = settings?.defaultValue ?? [];
		this.disabled = settings?.disabled ?? false;
		this.event = {
			onSelect: undefined,
			...settings?.event,
		};
		this.input = true;
		this.inputType = settings?.inputType ?? 'text';
		this.kdata = {
			class_kid:  undefined,
			create:     true,
			kid:        undefined,
			lastForm:   true,
			linker_kid: '0',
			method:     [],
			mf_custom:  null,
			mf_dico:    false,
			mf_order:   'ALL',
			mf_suggest: undefined,
			path:       [],
			pictures:   false,
			submit:     true,
			type_kid:   'K_NODE,STRING',
			uploadFile: false,
			...settings?.kdata,
		};
		this.ktable = {
			node:    settings?.ktable?.node,
			cols:    settings?.ktable?.cols ?? [],
			options: {
				actions:     {
					delete:  settings?.ktable?.options?.actions?.delete ?? true,
					refresh: settings?.ktable?.options?.actions?.refresh ?? true,
					update:  settings?.ktable?.options?.actions?.update ?? true,
					upload:  settings?.ktable?.options?.actions?.upload ?? false,
				},
				height:      settings?.ktable?.options?.height ?? 200,
				mode:        settings?.ktable?.options?.mode ?? 'normal',
				packet_size: settings?.ktable?.options?.packet_size ?? 50,
				parent:      settings?.ktable?.options?.parent,
				tree:        settings?.ktable?.options?.tree ?? true,
			},
			query:   settings?.ktable?.query ?? {},
		};
		this.mode = settings?.mode ?? 'label';
		this.options = {
			displayAddBtn:        settings?.options?.displayAddBtn ?? true,
			displayExpandButton:  settings?.options?.displayExpandButton ?? true,
			displaySuggestBtn:    settings?.options?.displaySuggestBtn ?? true,
			displaySuggestOnLoad: settings?.options?.displaySuggestOnLoad ?? null,
			displayValues:        settings?.options?.displayValues ?? true,
			focusSearch:          settings?.options?.focusSearch ?? null,
			icon:                 settings?.options?.icon ?? false,
			uniqueKid:            settings?.options?.uniqueKid ?? false,
		};
		this.placeholder = settings?.placeholder ?? '';
		this.validate = {
			card:   new Card(settings?.validate?.card ?? '0-N'),
			custom: settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
		};
	}
}
